import { Link } from 'react-router-dom';
import { REPORTS, REPORT_GROUP_LABELS, type ReportGroup } from '@codepass/shared';
import { useAuth } from '@/auth/AuthProvider';
import { Badge, Card, CardBody, CardHeader, CardTitle } from '@/components/ui';
import { PageHeader } from '@/components/domain';

/**
 * Rapportbiblioteket - PRD par. 3.2 (/rapporter).
 *
 * Kataloget staar i @codepass/shared og ikke her; hvilke rapporter en rolle ser, vaelges paa
 * /admin/roller, og serveren afviser resten. Siden viser kun det, brugeren maa se - et kort, der
 * foerer til en 403, er en blindgyde.
 */

const GROUPS: readonly ReportGroup[] = ['finance', 'operations'];

export function ReportsPage() {
  const { can, canSeeReport } = useAuth();
  const visible = REPORTS.filter((report) => canSeeReport(report.key));

  return (
    <>
      <PageHeader
        title="Rapporter"
        description={
          /* The files are 'Eksportér rapporter' - without it, the page does not promise them. */
          can('reports.export')
            ? 'Hver rapport kan ses her og hentes som PDF eller CSV til Excel.'
            : 'Hver rapport kan ses her.'
        }
      />

      {GROUPS.map((group) => {
        const reports = visible.filter((report) => report.group === group);
        if (reports.length === 0) return null;

        return (
          <section key={group} className="mb-6">
            <h2 className="mb-3 text-sm font-semibold text-ink-muted">
              {REPORT_GROUP_LABELS[group]}
            </h2>
            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {reports.map((report) => (
                <Link key={report.key} to={`/rapporter/${report.path}`} className="block">
                  <Card className="h-full transition-colors hover:bg-canvas">
                    <CardHeader className="flex items-center justify-between gap-2">
                      <CardTitle>{report.title}</CardTitle>
                      <Badge tone="neutral">
                        {report.period === 'month' ? 'Pr. måned' : 'Som nu'}
                      </Badge>
                    </CardHeader>
                    <CardBody>
                      <p className="text-xs text-ink-muted">{report.description}</p>
                    </CardBody>
                  </Card>
                </Link>
              ))}
            </div>
          </section>
        );
      })}
    </>
  );
}
